export class Section {
    constructor({
        id,
        title,
        index,
        keywords = [],
        chapters = [],
        exhibitionType = 'landscape'
    }) {
        this.id = id;
        this.title = title;
        this.index = index;
        this.keywords = keywords;
        this.chapters = chapters;
        this.exhibitionType = exhibitionType;
    }

    static fromAPI(apiData) {
        // Transformar os chapters do formato do backend para o formato do frontend
        const transformedChapters = (apiData.section_chapters || []).map(chapter => ({
            index: chapter.chapter_index,
            type: chapter.chapter_type,
            content_id: chapter.chapter_content?.content_id,
            serie_id: chapter.chapter_serie?.serie_id
        }));

        return new Section({
            id: apiData.section_id,
            title: apiData.section_title,
            index: apiData.section_index,
            keywords: apiData.section_keywords || [],
            chapters: transformedChapters,
            exhibitionType: apiData.section_exhibition_type || 'landscape'
        });
    }

    toAPI() {
        return {
            section_id: this.id,
            section_title: this.title,
            section_index: this.index,
            section_keywords: this.keywords,
            section_chapters: this.chapters,
            section_exhibition_type: this.exhibitionType
        };
    }
} 